import React, { useMemo } from "react";
import {
  ResponsiveContainer,
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  CartesianGrid,
  LineChart,
  Line,
  ScatterChart,
  Scatter,
} from "recharts";

const ChartPage2 = ({ filtered }) => {
  console.log("cp2", filtered);

  const tradesPerHour = useMemo(() => {
    if (!filtered) return [];
    const hours = Array(24).fill(0);
    filtered.forEach((t) => {
      const h = new Date(t.open).getHours();
      hours[h]++;
    });
    return hours.map((count, i) => ({ hour: `${i}:00`, trades: count }));
  }, [filtered]);

  const durationBuckets = useMemo(() => {
    if (!filtered) return [];
    const buckets = [
      { label: "<5m", min: 0, max: 5, count: 0 },
      { label: "5-15m", min: 5, max: 15, count: 0 },
      { label: "15-30m", min: 15, max: 30, count: 0 },
      { label: "30-60m", min: 30, max: 60, count: 0 },
      { label: "1-3h", min: 60, max: 180, count: 0 },
      { label: ">3h", min: 180, max: Infinity, count: 0 },
    ];
    filtered.forEach((t) => {
      const d = t.durationMin;
      const bucket = buckets.find((b) => d >= b.min && d < b.max);
      if (bucket) bucket.count++;
    });
    return buckets.map((b) => ({ label: b.label, count: b.count }));
  }, [filtered]);

  // Ganancias acumuladas
  const cumulativeProfit = useMemo(() => {
    if (!filtered) return [];
    let acc = 0;
    return filtered
      .slice()
      .sort((a, b) => a.open - b.open)
      .map((t, i) => {
        acc += t.profit;
        return { idx: i + 1, profit: acc };
      });
  }, [filtered]);

  // Ratio Tiempo/Ganancia (scatter data)
  const timeVsProfit = useMemo(() => {
    if (!filtered) return [];
    return filtered.map((t) => ({
      duration: +t.durationMin.toFixed(1), // minutos
      profit: t.profit, // CLP
    }));
  }, [filtered]);

  return (
    <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
      {/* Trades por hora */}
      <div className="p-4 bg-[#1f2a40] rounded shadow">
        <h3 className="mb-2 font-semibold">Cantidad de Trades por Hora</h3>
        <ResponsiveContainer width="100%" height={200}>
          <BarChart data={tradesPerHour}>
            <CartesianGrid stroke="#2a344b" />
            <XAxis dataKey="hour" tick={{ fill: "#cbd5e1" }} />
            <YAxis tick={{ fill: "#cbd5e1" }} />
            <Tooltip />
            <Bar dataKey="trades" fill="#818cf8" />
          </BarChart>
        </ResponsiveContainer>
      </div>

      {/* Distribución de duración */}
      <div className="p-4 bg-[#1f2a40] rounded shadow">
        <h3 className="mb-2 font-semibold">Duración de los Trades</h3>
        <ResponsiveContainer width="100%" height={200}>
          <BarChart data={durationBuckets}>
            <CartesianGrid stroke="#2a344b" />
            <XAxis dataKey="label" tick={{ fill: "#cbd5e1" }} />
            <YAxis tick={{ fill: "#cbd5e1" }} />
            <Tooltip />
            <Bar dataKey="count" fill="#f87171" />
          </BarChart>
        </ResponsiveContainer>
      </div>

      {/* Ganancias acumuladas */}
      <div className="p-4 bg-[#1f2a40] rounded shadow col-span-1 lg:col-span-2">
        <h3 className="mb-2 font-semibold">Ganancias Acumuladas (CLP)</h3>
        <ResponsiveContainer width="100%" height={250}>
          <LineChart data={cumulativeProfit}>
            <CartesianGrid stroke="#2a344b" />
            <XAxis dataKey="idx" tick={{ fill: "#cbd5e1" }} />
            <YAxis tick={{ fill: "#cbd5e1" }} />
            <Tooltip />
            <Line type="monotone" dataKey="profit" stroke="#34d399" />
          </LineChart>
        </ResponsiveContainer>
      </div>

      {/* Ratio Tiempo/Ganancia */}
      <div className="p-4 bg-[#1f2a40] rounded shadow col-span-1 lg:col-span-2">
        <h3 className="mb-2 font-semibold">Ratio Tiempo / Ganancia</h3>
        <ResponsiveContainer width="100%" height={250}>
          <ScatterChart>
            <CartesianGrid stroke="#2a344b" />
            <XAxis
              type="number"
              dataKey="duration"
              name="Duración (min)"
              tick={{ fill: "#cbd5e1" }}
            />
            <YAxis
              type="number"
              dataKey="profit"
              name="Profit (CLP)"
              tick={{ fill: "#cbd5e1" }}
            />
            <Tooltip cursor={{ strokeDasharray: "3 3" }} />
            <Scatter data={timeVsProfit} fill="#facc15" />
          </ScatterChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
};

export default ChartPage2;
